<h1>{{ 'turbo.core.AmountDialog.txtHeadline' | translate : 'Specify amount' }}</h1>
<div>
    <mat-form-field style="width: 100%; min-width: 150px;" appearance="outline">
      <input matInput type="text" placeholder="{{'turbo.core.AmountDialog.txtAmount' | translate : 'Amount'}}" required [(ngModel)]="amount" [disabled]="sending"/>
    </mat-form-field>
    <mat-form-field style="width: 100%; min-width: 150px;" *ngIf="showComment" appearance="outline">
      <textarea matInput placeholder="{{'turbo.core.AmountDialog.txtComment' | translate : 'Comment'}}" [(ngModel)]="message" matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="3" [disabled]="sending"></textarea>
    </mat-form-field>
  <div style="text-align: center;">
    <button mat-raised-button style="margin: 2px;" color="primary" (click)="confirm()" [disabled]="sending">{{ 'turbo.core.AmountDialog.cmdConfirm' | translate : 'Confirm' }}</button>
    <button mat-button style="margin: 2px;" [mat-dialog-close]="'Cancel'">{{ 'turbo.core.messagebox.cmdCancel' | translate : 'Cancel' }}</button>
  </div>
</div>
<mat-progress-bar mode="indeterminate" style="margin-left: -24px; margin-bottom: -24px; width: calc(100% + 48px); margin-top: 24px;" *ngIf="sending"></mat-progress-bar>
